import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnClientList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const ClientList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [clientList, setClientList] = useState([]);
  const [clientListCount, setClientListCount] = useState(0);
  const [clientListPerPage, setClientListPerPage] = useState(10);
  const [activeClientListPage, setActiveClientListPage] = useState(1);
  const [searchClientListFilter, setSearchClientListFilter] = useState("");
  const [columnClientListSorter, setColumnClientListSorter] = useState({ column: "createdAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchClientListFilter,
      limit: clientListPerPage,
      offset: clientListPerPage * activeClientListPage - clientListPerPage,
      sort:
        (columnClientListSorter &&
          `${columnClientListSorter.column}%${columnClientListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllClients(queries);
  }, [
    searchClientListFilter,
    clientListPerPage,
    activeClientListPage,
    columnClientListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveClientListPage(1)
    setSearchClientListFilter(search);
  }

  const fetchAllClients = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/client?${queries}`
    })
      .then(({ data }) => {
        const tempClientList = data?.value?.map((d) => ({
          ...d,
          pic_contact_number: `${d?.country?.phone_code}${d?.pic_contact_number}`
        }));

        setClientList(tempClientList);
        if (activeClientListPage === 1) {
          setClientListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/client/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          showSuccess('Client has been successfully deleted')
          fetchAllClients()
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/client/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={showConfirmDelete?.item?.name}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/client/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Client
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Client List</h4>}
        bodyContent={
          <AppTable
            clientListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnClientList}
            tableContent={clientList}
            contentPerPage={clientListPerPage}
            activeContentPage={activeClientListPage}
            contentCount={clientListCount}
            searchContentFilter={searchClientListFilter}
            setActiveContentPage={setActiveClientListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setClientListPerPage}
            setColumnContentSorter={setColumnClientListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default ClientList